Boolean(process.env.REACT_APP_HIDE_UNSELECTED_CHECKBOXES_IN_SUMMARY);
//# sourceMappingURL=QuestionAnswerCheckboxSnippet.constants.js.map
